import ks from "../ReUsableTS/kBrowserShared";
import { kTime } from "../ReUsableTS/kBrowserObjects";
import LNG from "./kLNG";
import { kZip } from "./Zip/kZip";
import { kFileDownload } from "./kFileDownload";
import { kHTMLCore } from "../kReusableCoreTS/kHTMLCore";
import { kEditableTable, kEditableTableRow, kEditableColumn, kHTMLEditableColType } from "./kEditableTable";

// Base64 encoding of OutputFormat.xlsx (single-tab workbook with empty table, TableStyleLight11)
const TEMPLATE_BASE64: string =
    "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";

export class kExcelExport {

    // ── Instance state carried through the async chain ──────────────────────
    private _Zip: any = null;
    private _FileName: string = "";
    private _Columns: Array<{ Def: kEditableColumn; OrigIndex: number }> = [];
    private _ExportRows: kEditableTableRow[] = [];
    private _Strings: string[] = [];
    private _StringMap: Map<string, number> = new Map();
    /** One entry per sheet of the workbook; _Columns / _ExportRows point at the sheet being written (_At). */
    private _Sheets: Array<{ Name: string; Columns: Array<{ Def: kEditableColumn; OrigIndex: number }>; Rows: kEditableTableRow[] }> = [];
    private _At: number = 0;

    // ── Public entry point ───────────────────────────────────────────────────

    public ExportTable = (Table: kEditableTable, FileName: string): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this.ExportTables([Table], ["Sheet1"], FileName);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport.ExportTable");
        }
    }

    /** Several grids as the sheets of ONE workbook, in the order given; SheetNames[i] names Tables[i]'s sheet
        (made acceptable to Excel by SheetName, and unique). One table = exactly ExportTable's file. */
    public ExportTables = (Tables: kEditableTable[], SheetNames: string[], FileName: string): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._FileName = FileName + ".xlsx";
            if (FileName.endsWith(".xlsx")) { this._FileName = FileName; }
            this._Strings = [];
            this._StringMap = new Map();
            this._Sheets = [];
            const Used: Set<string> = new Set();
            for (let T: number = 0; T < Tables.length; T++) {
                let Name: string = "Sheet" + (T + 1);
                if (T < SheetNames.length) { Name = kExcelExport.SheetName(SheetNames[T], T); }
                let Unique: string = Name;
                let N: number = 2;
                while (Used.has(Unique.toLowerCase())) { Unique = Name.substring(0, 28) + " " + N; N++; }
                Used.add(Unique.toLowerCase());
                this._At = T;
                // 1. Collect visible columns (Width > 0)
                this._Columns = [];
                for (let Idx: number = 0; Idx < Tables[T].Columns.Items.length; Idx++) {
                    const Def: kEditableColumn = Tables[T].Columns.Items[Idx];
                    if (Def.Width > 0) {
                        this._Columns.push({ Def, OrigIndex: Idx });
                    }
                }
                // 2. Register column headers as shared strings (the first sheet's are indices 0..N-1)
                for (const Col of this._Columns) {
                    this._RegisterString(Col.Def.Title);
                }
                // 3 & 4. Collect non-empty rows and register their string values
                this._CollectExportRows(Tables[T]);
                this._RegisterDataStrings();
                this._Sheets.push({ Name: Unique, Columns: this._Columns, Rows: this._ExportRows });
            }
            if (this._Sheets.length === 0) { return; }
            this._LoadTemplate();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport.ExportTables");
        }
    }

    /** A sheet name Excel accepts: none of [ ] : * ? / \, not empty, at most 31 characters. */
    public static SheetName = (Wanted: string, Index: number): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            let Clean: string = "";
            for (const Ch of String(Wanted)) {
                if ("[]:*?/\\".indexOf(Ch) >= 0) { Clean += " "; } else { Clean += Ch; }
            }
            Clean = Clean.trim().substring(0, 31).trim();
            if (Clean.length === 0) { return "Sheet" + (Index + 1); }
            return Clean;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport.SheetName");
            return "Sheet" + (Index + 1);
        }
    }

    private _CollectExportRows = (Table: kEditableTable): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._ExportRows = [];
            for (const Row of Table.Rows.Items) {
                if (Row.Hidden) { continue; }
                let HasValue: boolean = false;
                for (const Col of this._Columns) {
                    let V: any = null;
                    if (Row.Cells[Col.OrigIndex]) { V = Row.Cells[Col.OrigIndex].CurrentValue; }
                    if (V !== null && V !== undefined && V !== "" && V !== 0 && V !== Col.Def.DefaultValue) {
                        HasValue = true;
                        break;
                    }
                }
                if (HasValue) {
                    this._ExportRows.push(Row);
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._CollectExportRows");
        }
    }

    private _RegisterDataStrings = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            for (const Row of this._ExportRows) {
                for (const Col of this._Columns) {
                    if (this._IsStringType(Col.Def.Type)) {
                        let V: any = null;
                        if (Row.Cells[Col.OrigIndex]) { V = Row.Cells[Col.OrigIndex].CurrentValue; }
                        if (V !== null && V !== undefined && V !== "") {
                            this._RegisterString(String(V));
                        }
                    }
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._RegisterDataStrings");
        }
    }

    // ── Async chain ──────────────────────────────────────────────────────────

    private _LoadTemplate = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._Zip = kZip.Empty();
            if (this._Zip === null) { return; }
            kZip.WriteText(this._Zip, "[Content_Types].xml", this._BuildContentTypes(), null);
            kZip.WriteText(this._Zip, "_rels/.rels", kExcelExport._ROOT_RELS, null);
            kZip.WriteText(this._Zip, "xl/_rels/workbook.xml.rels", this._BuildWorkbookRels(), null);
            kZip.WriteText(this._Zip, "xl/workbook.xml", this._BuildWorkbook(), null);
            for (let I: number = 0; I < this._Sheets.length; I++) {
                kZip.WriteText(this._Zip, "xl/worksheets/_rels/sheet" + (I + 1) + ".xml.rels", kExcelExport._SheetRels(I), null);
            }
            this._WriteStyles();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._LoadTemplate");
        }
    }

    /** [Content_Types].xml with one worksheet + table override per sheet. */
    private _BuildContentTypes = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            let Sheets: string = "";
            let Tables: string = "";
            for (let I: number = 1; I <= this._Sheets.length; I++) {
                Sheets += '<Override PartName="/xl/worksheets/sheet' + I + '.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>';
                Tables += '<Override PartName="/xl/tables/table' + I + '.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"/>';
            }
            return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
                + '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'
                + '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>'
                + '<Default Extension="xml" ContentType="application/xml"/>'
                + '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>'
                + Sheets
                + '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>'
                + '<Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/>'
                + Tables
                + '</Types>';
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildContentTypes");
            return "";
        }
    }

    private static _ROOT_RELS: string = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
        + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
        + '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>'
        + '</Relationships>';

    /** Workbook relationships: rId1..rIdN = the sheets (one sheet = rId1, as before), then styles and shared strings. */
    private _BuildWorkbookRels = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            const N: number = this._Sheets.length;
            let Out: string = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
                + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';
            for (let I: number = 1; I <= N; I++) {
                Out += '<Relationship Id="rId' + I + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet' + I + '.xml"/>';
            }
            Out += '<Relationship Id="rId' + (N + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>'
                + '<Relationship Id="rId' + (N + 2) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml"/>'
                + '</Relationships>';
            return Out;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildWorkbookRels");
            return "";
        }
    }

    private _BuildWorkbook = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            let Sheets: string = "";
            for (let I: number = 0; I < this._Sheets.length; I++) {
                Sheets += '<sheet name="' + kHTMLCore.EscapeAttr(this._Sheets[I].Name) + '" sheetId="' + (I + 1) + '" r:id="rId' + (I + 1) + '"/>';
            }
            return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
                + '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'
                + '<sheets>' + Sheets + '</sheets>'
                + '</workbook>';
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildWorkbook");
            return "";
        }
    }

    /** Sheet I's relationship to its own table (table I+1). */
    private static _SheetRels = (I: number): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
                + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
                + '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/table" Target="../tables/table' + (I + 1) + '.xml"/>'
                + '</Relationships>';
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._SheetRels");
            return "";
        }
    }

    private _WriteStyles = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            kZip.WriteText(this._Zip, "xl/styles.xml", this._BuildStylesXml(), this._OnStylesWritten);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._WriteStyles");
        }
    }

    private _OnStylesWritten = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._WriteSharedStrings();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._OnStylesWritten");
        }
    }

    private _WriteSharedStrings = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            kZip.WriteText(this._Zip, "xl/sharedStrings.xml", this._BuildSharedStringsXml(), this._OnSharedStringsWritten);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._WriteSharedStrings");
        }
    }

    private _OnSharedStringsWritten = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._At = 0;
            this._WriteSheet();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._OnSharedStringsWritten");
        }
    }

    private _WriteSheet = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._Columns = this._Sheets[this._At].Columns;
            this._ExportRows = this._Sheets[this._At].Rows;
            kZip.WriteText(this._Zip, "xl/worksheets/sheet" + (this._At + 1) + ".xml", this._BuildSheetXml(), this._OnSheetWritten);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._WriteSheet");
        }
    }

    private _OnSheetWritten = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._WriteTable();
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._OnSheetWritten");
        }
    }

    private _WriteTable = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            kZip.WriteText(this._Zip, "xl/tables/table" + (this._At + 1) + ".xml", this._BuildTableXml(), this._OnTableWritten);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._WriteTable");
        }
    }

    private _OnTableWritten = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            this._At++;
            if (this._At < this._Sheets.length) { this._WriteSheet(); return; }
            kZip.ToBlob(this._Zip, this._OnBlobReady);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._OnTableWritten");
        }
    }

    private _OnBlobReady = (ExportBlob?: Blob): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if (!ExportBlob) { ks.KGlobalErrorHandler(new Error("Blob generation failed"), "kExcelExport._OnBlobReady"); return; }
            // ⚠ MIGRATED to kFileDownload.SaveBlob on 2026-08-18. This was copy ONE of four
            // hand-written anchor idioms in this tree; the shared class is byte-for-byte what this
            // did, plus a `finally` around the removal — so a click handler that throws no longer
            // leaves the anchor in <body>, which copy four does on every single export.
            kFileDownload.SaveBlob(ExportBlob, this._FileName);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._OnBlobReady");
        }
    }

    // ── XML builders ─────────────────────────────────────────────────────────

    private _BuildStylesXml = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
                `<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">` +
                `<numFmts count="1"><numFmt numFmtId="164" formatCode="#,##0.00"/></numFmts>` +
                `<fonts count="1"><font><sz val="11"/><color theme="1"/><name val="Aptos Narrow"/><family val="2"/><scheme val="minor"/></font></fonts>` +
                `<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>` +
                `<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>` +
                `<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>` +
                `<cellXfs count="3">` +
                `<xf numFmtId="0"   fontId="0" fillId="0" borderId="0" xfId="0"/>` +
                `<xf numFmtId="14"  fontId="0" fillId="0" borderId="0" xfId="0"><alignment/></xf>` +
                `<xf numFmtId="164" fontId="0" fillId="0" borderId="0" xfId="0"/>` +
                `</cellXfs>` +
                `<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>` +
                `<dxfs count="0"/>` +
                `<tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleLight16"/>` +
                `</styleSheet>`;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildStylesXml");
            return "";
        }
    }

    private _BuildSharedStringsXml = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            const Count: number = this._Strings.length;
            let Items: string = "";
            for (const S of this._Strings) {
                Items += `<si><t xml:space="preserve">${kHTMLCore.EscapeAttr(String(S))}</t></si>`;
            }
            return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
                `<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="${Count}" uniqueCount="${Count}">` +
                Items +
                `</sst>`;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildSharedStringsXml");
            return "";
        }
    }

    private _BuildSheetXml = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            const ColCount: number = this._Columns.length;
            const RowCount: number = this._ExportRows.length;
            const LastCol: string = this._ColLetter(ColCount - 1);
            const LastRow: number = RowCount + 1;
            let Selected: string = "";
            if (this._At === 0) { Selected = `tabSelected="1" `; }
            return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
                `<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">` +
                `<dimension ref="A1:${LastCol}${LastRow}"/>` +
                `<sheetViews><sheetView ${Selected}workbookViewId="0"/></sheetViews>` +
                `<sheetFormatPr defaultRowHeight="15"/>` +
                this._BuildColsXml() +
                `<sheetData>${this._BuildHeaderRowXml()}${this._BuildDataRowsXml()}</sheetData>` +
                `<pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3"/>` +
                `<tableParts count="1"><tablePart r:id="rId1"/></tableParts>` +
                `</worksheet>`;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildSheetXml");
            return "";
        }
    }

    private _BuildColsXml = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            let Xml: string = `<cols>`;
            for (let Idx: number = 0; Idx < this._Columns.length; Idx++) {
                const WidthChars: number = Math.max(8, Math.min(60, this._Columns[Idx].Def.Width / 7));
                Xml += `<col min="${Idx + 1}" max="${Idx + 1}" width="${WidthChars.toFixed(2)}" customWidth="1"/>`;
            }
            Xml += `</cols>`;
            return Xml;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildColsXml");
            return "";
        }
    }

    private _BuildHeaderRowXml = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            const ColCount: number = this._Columns.length;
            let Cells: string = "";
            for (let Idx: number = 0; Idx < this._Columns.length; Idx++) {
                const CellRef: string = this._ColLetter(Idx) + "1";
                let StrIdx: number = 0;
                if (this._StringMap.has(this._Columns[Idx].Def.Title)) {
                    StrIdx = this._StringMap.get(this._Columns[Idx].Def.Title) as number;
                }
                Cells += `<c r="${CellRef}" t="s"><v>${StrIdx}</v></c>`;
            }
            return `<row r="1" spans="1:${ColCount}">${Cells}</row>`;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildHeaderRowXml");
            return "";
        }
    }

    private _BuildDataRowsXml = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            const ColCount: number = this._Columns.length;
            let Rows: string = "";
            for (let RowIdx: number = 0; RowIdx < this._ExportRows.length; RowIdx++) {
                const RowNum: number = RowIdx + 2;
                let Cells: string = "";
                for (let ColIdx: number = 0; ColIdx < this._Columns.length; ColIdx++) {
                    const CellRef: string = this._ColLetter(ColIdx) + RowNum;
                    let RawValue: any = null;
                    if (this._ExportRows[RowIdx].Cells[this._Columns[ColIdx].OrigIndex]) {
                        RawValue = this._ExportRows[RowIdx].Cells[this._Columns[ColIdx].OrigIndex].CurrentValue;
                    }
                    Cells += this._BuildCell(CellRef, this._Columns[ColIdx].Def, RawValue);
                }
                Rows += `<row r="${RowNum}" spans="1:${ColCount}">${Cells}</row>`;
            }
            return Rows;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildDataRowsXml");
            return "";
        }
    }

    private _BuildTableXml = (): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            const ColCount: number = this._Columns.length;
            const RowCount: number = this._ExportRows.length;
            const LastCol: string = this._ColLetter(ColCount - 1);
            const LastRow: number = RowCount + 1;
            const Ref: string = `A1:${LastCol}${LastRow}`;
            const TableNo: number = this._At + 1;
            let ColsXml: string = "";
            for (let Idx: number = 0; Idx < this._Columns.length; Idx++) {
                ColsXml += `<tableColumn id="${Idx + 1}" name="${kHTMLCore.EscapeAttr(String(this._Columns[Idx].Def.Title))}"/>`;
            }
            return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>` +
                `<table xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" ` +
                `id="${TableNo}" name="Table${TableNo}" displayName="Table${TableNo}" ref="${Ref}" totalsRowShown="0">` +
                `<autoFilter ref="${Ref}"/>` +
                `<tableColumns count="${ColCount}">${ColsXml}</tableColumns>` +
                `<tableStyleInfo name="TableStyleLight11" showFirstColumn="0" showLastColumn="0" showRowStripes="1" showColumnStripes="0"/>` +
                `</table>`;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildTableXml");
            return "";
        }
    }

    // ── Cell XML builder ─────────────────────────────────────────────────────

    /** A shared-string cell, interning Text into the workbook's string table.
        Used by both the RichHtml and the default (plain text) cases. */
    private _SharedStringCell = (CellRef: string, Text: string): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            if (Text === "") { return `<c r="${CellRef}"/>`; }
            // if/else, NOT default-then-override: _RegisterString APPENDS to the
            // shared-string table, so calling it unconditionally would add a
            // duplicate entry for every string already registered.
            let Idx: number;
            if (this._StringMap.has(Text)) {
                Idx = this._StringMap.get(Text) as number;
            } else {
                Idx = this._RegisterString(Text);
            }
            return `<c r="${CellRef}" t="s"><v>${Idx}</v></c>`;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._SharedStringCell");
            return "";
        }
    };

    /** A numeric cell. StyleAttr carries the workbook style (currency uses s="2");
        a non-numeric value yields an EMPTY cell rather than the string "NaN". */
    private _NumericCell = (CellRef: string, Value: any, StyleAttr: string): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            const Num: number = Number(Value);
            if (isNaN(Num)) { return `<c r="${CellRef}"/>`; }
            return `<c r="${CellRef}"${StyleAttr}><v>${Num}</v></c>`;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._NumericCell");
            return "";
        }
    };

    private _BuildCell = (CellRef: string, ColDef: kEditableColumn, Value: any): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            if (Value === null || Value === undefined) { return `<c r="${CellRef}"/>`; }

            switch (ColDef.Type) {
                case kHTMLEditableColType.Number: {
                    return this._NumericCell(CellRef, Value, "");
                }
                case kHTMLEditableColType.Currency: {
                    return this._NumericCell(CellRef, Value, ` s="2"`);
                }
                case kHTMLEditableColType.Date:
                case kHTMLEditableColType.DateTime: {
                    if (!Value || !(Value as kTime).Year) { return `<c r="${CellRef}"/>`; }
                    const Serial: number = this._ToExcelDate(Value as kTime);
                    return `<c r="${CellRef}" s="1"><v>${Serial}</v></c>`;
                }
                case kHTMLEditableColType.Checkbox:
                case kHTMLEditableColType.Radio: {
                    let BoolVal: string = "0";
                    if (Value === true || Value === 1 || Value === "true" || Value === "☑") { BoolVal = "1"; }
                    return `<c r="${CellRef}" t="b"><v>${BoolVal}</v></c>`;
                }
                case kHTMLEditableColType.RichHtml: {
                    // Excel cells hold flat text — export the visible text,
                    // not the markup (mirrors the grid's clipboard behaviour,
                    // including the "[Diagram]" token for inserted diagrams).
                    return this._SharedStringCell(CellRef,
                        ks.PlainTextFromHTMLWithDiagramToken(String(Value), "[" + LNG.DIAGRAM + "]").trim());
                }
                default: {
                    return this._SharedStringCell(CellRef, String(Value));
                }
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._BuildCell");
            return "";
        }
    }

    // ── Helpers ───────────────────────────────────────────────────────────────

    private _ColLetter = (N: number): string => {
        if (ks.KErrorMode === true) { return ""; }
        try {
            let S: string = "";
            let Remaining: number = N + 1;
            while (Remaining > 0) {
                const R: number = (Remaining - 1) % 26;
                S = String.fromCharCode(65 + R) + S;
                Remaining = Math.floor((Remaining - 1) / 26);
            }
            return S;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._ColLetter");
            return "";
        }
    }

    private _ToExcelDate = (D: kTime): number => {
        if (ks.KErrorMode === true) { return 0; }
        try {
            const DateObj: Date = new Date(D.Year, D.Month - 1, D.Day);
            const Epoch: Date = new Date(1899, 11, 30);
            return Math.round((DateObj.getTime() - Epoch.getTime()) / 86400000);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._ToExcelDate");
            return 0;
        }
    }

    private _RegisterString = (S: string): number => {
        if (ks.KErrorMode === true) { return 0; }
        try {
            if (this._StringMap.has(S)) { return this._StringMap.get(S) as number; }
            const Idx: number = this._Strings.length;
            this._Strings.push(S);
            this._StringMap.set(S, Idx);
            return Idx;
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._RegisterString");
            return 0;
        }
    }

    private _IsStringType = (Type: kHTMLEditableColType): boolean => {
        if (ks.KErrorMode === true) { return false; }
        try {
            switch (Type) {
                case kHTMLEditableColType.Text:
                case kHTMLEditableColType.Select:
                case kHTMLEditableColType.SelectMulti:
                case kHTMLEditableColType.Color:
                case kHTMLEditableColType.Button:
                case kHTMLEditableColType.Link:
                case kHTMLEditableColType.Image:
                case kHTMLEditableColType.File:
                case kHTMLEditableColType.Time:
                    return true;
                default:
                    return false;
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kExcelExport._IsStringType");
            return false;
        }
    }
}
